module.exports = __webpack_public_path__ + "img/flag-BR.15883419.svg";